import { useEffect, useState } from 'react';

/**
 * Mobil kártyalisták lapozása: alapból `batch` elem látszik, a "Több betöltése"
 * gomb mindig `batch`-csel többet mutat. A lista hosszának változásakor
 * (pl. szűrés) visszaáll az első adagra.
 */
export function useBatchedList<T>(items: T[], batch = 5) {
  const [shown, setShown] = useState(batch);

  // A hossz mellett az első elemet is figyeljük, hogy azonos hosszú, de más
  // tartalmú szűrési eredménynél is visszaálljon az első adagra.
  const firstItem = items.length > 0 ? items[0] : undefined;
  useEffect(() => {
    setShown(batch);
  }, [items.length, firstItem, batch]);

  const visible = items.slice(0, shown);
  const hasMore = items.length > shown;
  const remaining = Math.max(0, items.length - shown);
  const loadMore = () => setShown((s) => s + batch);

  return { visible, hasMore, remaining, loadMore };
}
